import { FC, memo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { InputField } from '@studenten/ui-components';
import { UserProfile } from 'api_entities/user/types';
import { socialValidationSchema } from './helpers';

import { Button, Form, InputWrapper } from './ProfileForm.styles';

export type SocialAccountsProps = {
  onSubmit: (values: Omit<SocialAccountsProps, 'onSubmit' | 'loading'>) => void;
  loading?: boolean;
} & Partial<Pick<UserProfile, 'twitter' | 'facebook' | 'instagram' | 'medium' | 'linkedin'>>;

const SocialAccounts: FC<SocialAccountsProps> = ({
  onSubmit,
  loading,
  twitter = '',
  facebook = '',
  instagram = '',
  linkedin = '',
  medium = '',
}) => {
  const { handleSubmit, formState, register } = useForm<
    Omit<SocialAccountsProps, 'onSubmit' | 'loading'>
  >({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: {
      twitter,
      facebook,
      instagram,
      linkedin,
      medium,
    },
    resolver: yupResolver(socialValidationSchema),
  });

  const { errors, isSubmitting } = formState;

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <InputWrapper>
        <InputField
          label="Twitter"
          {...register('twitter')}
          error={errors.twitter?.message}
          withErrorMessage={!!errors.twitter}
          touched={!!errors.twitter}
        />
      </InputWrapper>

      <InputWrapper>
        <InputField
          label="Facebook"
          {...register('facebook')}
          error={errors.facebook?.message}
          withErrorMessage={!!errors.facebook}
          touched={!!errors.facebook}
        />
      </InputWrapper>

      <InputWrapper>
        <InputField
          label="Instagram"
          {...register('instagram')}
          error={errors.instagram?.message}
          withErrorMessage={!!errors.instagram}
          touched={!!errors.instagram}
        />
      </InputWrapper>

      <InputWrapper>
        <InputField
          label="Medium"
          {...register('medium')}
          error={errors.medium?.message}
          withErrorMessage={!!errors.medium}
          touched={!!errors.medium}
        />
      </InputWrapper>

      <InputWrapper>
        <InputField
          label="Linked In"
          {...register('linkedin')}
          error={errors.linkedin?.message}
          withErrorMessage={!!errors.linkedin}
          touched={!!errors.linkedin}
        />
      </InputWrapper>

      <Button disabled={isSubmitting || loading}>Update Information</Button>
    </Form>
  );
};

export default memo(SocialAccounts);
